































import { Note } from "../../models/Note";
import { NoteApi } from "../../api/NoteApi";
import JournalEntryModal from "../../journal/JournalEntryModal.vue";
import { JournalEntry } from "../../models/JournalEntry";
import ConfirmSuppression from "../../core/Modals/ConfirmSuppression";

const RAISON_DOSSIER = "Transformé en dossier";

export default {
    name: "NoteDisplay",
    components: { JournalEntryModal },
    props: {
        note: Note,
    },
    data() {
        return {
            NoteApi: new NoteApi(),
            showJournalEntryModal: false,
        };
    },
    methods: {
        createJournalEntry() {
            this.showJournalEntryModal = true;
        },
        onJournalEntryModalClose(data) {
            let self = this;
            if (data && data instanceof JournalEntry) {
                // Le post-it part à la corbeille sans saisie : la raison est
                // connue.
                this.NoteApi.delete(self.note.id, RAISON_DOSSIER).then(
                    function (note) {
                        self.$emit("close-modal");
                        window.location.href = data.link;
                    }
                );
            }
            self.showJournalEntryModal = false;
        },
        deleteNote() {
            let self = this;
            ConfirmSuppression.demanderRaison(
                "Voulez vous supprimer ce post-it ?"
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.NoteApi.delete(self.note.id, raison)
                    .then((response) => {
                        self.$emit("note-deleted");
                    })
                    .catch(() => {
                        swal("Le post-it n'a pas pu être supprimé.", "", "error");
                    });
            });
        },
    },
};
